export const visit = (vm, at) => {
at({ "nl": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Sorry, we konden je e-mailadres niet verifi\xEBren." } } } });
};